<template>
  <div>
    <!-- 上传流水 -->
    <el-dialog :title="$t('message.uploadStream')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      :width="list == false ? '650px' : '1300px'" center v-loading="loading">
      <div class="content" v-if="list == false">
        <div class="row">
          <!-- 选择文件 -->
          <div class="label">{{ $t('message.selectFile') }}：</div>
          <div class="val">
            <el-upload class="upload-demo" drag :action="baseURL + '/bill.bank.justMatch'" multiple
              :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" :limit="1" :headers="{
                AdminToken: 'Bearer ' + token
              }" :auto-upload="false" ref="upload">
              <i class="el-icon-upload"></i>
              <div class="el-upload__tip" slot="tip">只能上传CSV，XLS，XLSX文件</div>
            </el-upload>
          </div>
        </div>
      </div>
      <div class="list" v-else>
        <el-table :data="list" :header-cell-style="{ background: '#EDEFF4' }" :cell-style="{
          'text-align': 'center',
        }" ref="multipleTable" :row-class-name="tableRowClassName" max-height="580px">
          <el-table-column align="center" label="NO" type="index" width="45">
          </el-table-column>
          <!--  导入日期-->
          <el-table-column align="center" :label="$t('message.importDate')" prop="created_at" width="100">
          </el-table-column>
          <!--  名义-->
          <el-table-column align="center" label="名义" prop="account">
          </el-table-column>
          <!--  金额-->
          <el-table-column align="center" label="金额" prop="amount_in" width="100">
          </el-table-column>
          <!--  匹配状态-->
          <el-table-column align="center" label="匹配状态" width="100">
            <template slot-scope="scope">
              <div>
                {{ scope.row.match_bill_user_id ? '已匹配' : '未匹配' }}
              </div>
            </template>
          </el-table-column>
          <!--  客户id-->
          <el-table-column align="center" label="客户id" prop="match_bill_user_id" width="100">
            <template slot-scope="scope">
              {{ scope.row.match_bill_user_id ? scope.row.match_bill_user_id : '' }}
            </template>
          </el-table-column>
          <!--  入金报告名义-->
          <el-table-column align="center" label="入金报告名义" width="100">
            <template slot-scope="scope">
              {{ scope.row.bill ? scope.row.bill.pay_realname : '' }}
            </template>
          </el-table-column>
          <!--  订单号-->
          <el-table-column align="center" label="订单号" prop="match_order_sn">
            <template slot-scope="scope">
              {{ scope.row.match_bill_user_id ? scope.row.match_order_sn : '' }}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="save" v-if="list == false">{{
          $t("message.ok")
        }}</el-button>
        <el-button type="primary" @click="handleExportExcel" v-else> 导出Excel</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false,
      loading: false,
      token: localStorage.getItem('japan_access_token'),
      list: [],
    };
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible) {
        this.list = []
      }
    }
  },
  methods: {
    // 标记颜色
    tableRowClassName({ row, rowIndex }) {
      if (row.match_bill_user_id == false) {
        return 'warning-row';
      }
      return '';
    },
    // 保存
    save() {
      this.$refs.upload.submit();
    },
    //上传前
    beforeAvatarUpload(file) {
      // console.log(file);
      this.loading = true;
      const xlsx = file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      const xls = file.type === "application/vnd.ms-excel";
      const csv = file.type === "text/csv";
      if (!xlsx && !xls && !csv) {
        this.loading = false;
        this.$message.error("只能上传.xls或者.xlsx或者csv");
      }
      return xlsx || xls || csv;
    },
    //添加修改图片
    handleAvatarSuccess(file) {
      this.loading = false;
      // this.dialogVisible = false
      this.$refs.upload.clearFiles();
      this.list = file.data.list
      // this.$parent.bankList()
      // this.$forceUpdate();
    },
    // excel导出
    handleExportExcel() {
      let list = []
      this.list.forEach(item => {
        let itemData = JSON.parse(JSON.stringify(item))
        if (item.match_bill_user_id) {
          itemData.status = '已匹配'
        } else {
          itemData.match_bill_user_id = ''
          itemData.match_order_sn = ''
          itemData.status = '未匹配'
        }
        list.push(itemData)
      })
      require.ensure([], () => {
        const { export_json_to_excel } = require('@/utlis/Export2Excel')
        const tHeader = ['导入日期', '名义', '金额', '匹配状态', '客户id', '入金报告名义', '订单号',]
        const filterVal = ['created_at', 'account', 'amount_in', 'status', 'match_bill_user_id', 'pay_realname', 'match_order_sn']

        const data = this.formatJson(filterVal, list)
        export_json_to_excel(tHeader, data, '上传的流水')
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]))
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px auto;

  .row {
    display: flex;
    margin-bottom: 20px;

    .label {
      line-height: 40px;
      flex: 1;
    }

    .val {
      flex: 3;
    }
  }

}

/deep/.el-table tbody .warning-row {
  background-color: rgba(245, 108, 108, 0.5) !important;
}

/deep/.el-table tbody .warning-row:hover>td {
  background-color: rgba(245, 108, 108, 0.5) !important;
}
</style>